export const addresses = {
  dotNounsArt: "0x6c383Ef7C9Bf496b5c847530eb9c49a3ED6E4C56",
};
